import React, { useEffect, useState } from "react";
import ImageLoading from "../../components/ImageLoading";
import TableFooter from "../../components/TableFooter";
import RightArrow from "../../images/RightArrow";
import { IoCloseSharp } from "react-icons/io5";
import Stepper from "../../components/Stepper";
import axios from "axios";
import { Link } from "react-router-dom";
import NoDataFound from "../../components/NoDataFound";
import { MdOutlineCancel } from "react-icons/md";

const LogModal = ({ closeInvokeModal, loanAction }) => {
  const [imageLoading, setImageLoading] = useState(false);
  const [filter, setFilter] = useState("");

  const [noOfRows, setNoOfRows] = useState(0);
  const [noOfPages, setNoOfPages] = useState(10);
  const [startIndex, setStartIndex] = useState(0);

  const [pageNo, setPageNo] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [endIndex, setEndIndex] = useState(rowsPerPage);
  const [divPosition, setDivPosition] = useState({
    top: 100,
    left: 100,
  });
  const [arrowPosition, setArrowPosition] = useState("top");
  const [showTimeLine, setShowTimeLine] = useState(false);
  const [underline, setUnderline] = useState(false);
  const [timelineData, setTimelineData] = useState([]);
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [timelineUser, setTimelineUser] = useState({
    name: "",
    reference_no: "",
  });
  const filterItems = [
    {
      value: "",
      text: "All",
    },
    {
      value: "cancelled",
      text: "Cancelled",
    },
    {
      value: "completed",
      text: "Completed",
    },
    {
      value: "failed",
      text: "Failed",
    },
  ];
  function truncateText(text, maxLength = 18) {
    if (text === null || text === undefined) return "---";
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    } else {
      return text;
    }
  }

  const fetchLogs = async (controller) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/${loanAction}/logs?per_page=${rowsPerPage}&filter_name_and_reference_no=${searchValue}&status=${filter}&page=${pageNo}`,
        options
      );
      if (res.data) {
        setData(res.data.invoke_data);
        setNoOfPages(res.data.total_page_count);
        setNoOfRows(res.data.total_records);
        setImageLoading(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  function formatString(str) {
    if (!str) return "";
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const handlePosition = (e, data) => {
    const rowRect = e.currentTarget.getBoundingClientRect();
    const topValue = (rowRect.bottom + window.scrollY).toFixed(2);
    const leftValue = rowRect.left + window.scrollX;
    const divTop = topValue > 420 ? topValue - 200 : topValue - 84;
    const divLeft = leftValue - 370;
    const arrowPos = topValue > 420 ? "bottom" : "top";

    setTimelineUser({
      name: data.name,
      reference_no: data.reference_no,
    });
    setTimelineData(
      data.timeline.map((item) => {
        return {
          name: formatString(item.status),
          description: item.created_at,
          href: "",
          status: item.status.includes("failed") ? "failed" : "current",
        };
      })
    );

    setDivPosition({ top: divTop, left: divLeft });
    setArrowPosition(arrowPos);
    setShowTimeLine(true);
  };

  const handleOverlay = (e) => {
    if (e.target === e.currentTarget) {
      setShowTimeLine(false);
      setUnderline(false);
    }
    return;
  };

  const getStatusColor = (status) => {
    if (!status) return { text: "", bg: "" };
    status = status.toLowerCase();
    const colorObject = {
      text: "",
      bg: " ",
    };
    switch (status) {
      case "completed":
        colorObject.text = "text-[#0ba300]";
        colorObject.bg = "bg-[#dbe8db]";
        break;
      case "cancelled":
        colorObject.text = "text-[#1963ba]";
        colorObject.bg = "bg-[#cce2fb]";
        break;
      case "failed":
        colorObject.text = "text-[#d30d00]";
        colorObject.bg = "bg-[#f8e9e8]";
        break;
      default:
        colorObject.text = "text-[#1963BA]";
        colorObject.bg = "bg-[#CCE2FB]";
        break;
    }

    return colorObject;
  };

  useEffect(() => {
    const controller = new AbortController();
    fetchLogs(controller);

    return () => {
      controller.abort();
    };
  }, [rowsPerPage, pageNo, filter, searchValue]);

  useEffect(() => {
    setEndIndex(Number(rowsPerPage));
  }, [rowsPerPage]);
  return (
    <div className="overlay z-50">
      <div
        className={`modal !w-[88%]  !p-4  !h-[90%] !text-left !bg-[#f1f1f6] !justify-normal`}
      >
        <div className=" w-full bg-white px-4  pt-[16px] rounded-lg ">
          <div className="  flex justify-between items-center">
            <p className=" text-[20px] font-semibold">
              {loanAction === "invoke" ? "Invoke" : "Revoke"} Logs
            </p>
            <button onClick={() => closeInvokeModal(false)}>
              <IoCloseSharp
                style={{
                  width: "20px",
                  height: "20px",
                }}
              />
            </button>
          </div>
          <div className=" text-sm  space-x-8 mt-2">
            {" "}
            {filterItems.map((item, index) => (
              <button
                key={index}
                className={`   ${
                  filter === item.value
                    ? "border-b-[3px] border-[#00394d]  font-semibold "
                    : ""
                }   py-[12px]`}
                onClick={() => {
                  setPageNo(1);
                  setFilter(item.value);
                }}
              >
                {item.text}
              </button>
            ))}
          </div>
        </div>
        {/* log header */}
        <div className=" px-4 mt-[12px] pt-[16px] flex justify-between items-center bg-white rounded-t-lg">
          <p className=" text-base font-bold">List of Loan</p>
          <div className="flex items-center">
            <div className="flex items-center pr-3 ">
              <div className="relative w-[240px]">
                <input
                  type="text"
                  placeholder="Search by name or reference no"
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                  }}
                  className="w-full text-xs h-8 border border-[#e0e0e0] rounded bg-[#f8f8f8] px-4 py-[14px] pr-10 focus:outline-none"
                />
                {searchValue && (
                  <button
                    onClick={() => setSearchValue("")}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 focus:outline-none"
                  >
                    <MdOutlineCancel color="#00394d" />
                  </button>
                )}
              </div>
            </div>
            <div className="flex"></div>
          </div>
        </div>
        {/* Log Table */}
        <div className="pt-3 w-full bg-white ">
          {imageLoading && (
            <div className="w-full h-[calc(100vh-340px)] flex items-center justify-center">
              <ImageLoading />
            </div>
          )}

          {data.length === 0 && !imageLoading && (
            <div className="w-full h-[calc(100vh-340px)] flex items-center justify-center">
              <NoDataFound />
            </div>
          )}
          {!imageLoading && data.length > 0 && (
            <table className="w-full box-border h-full flex flex-col z-0   ">
              <thead className="text-sm font-semibold z-0 overflow-visible ">
                <tr className="w-full flex items-center">
                  <th className="text-left pl-6 pr-4 pt-3 pb-2 w-[17%]">
                    Name
                  </th>
                  <th className="text-left  pt-3 pb-2 w-[16%]">Reference no</th>
                  <th className={`text-left w-[18%]`}>
                    {loanAction === "invoke" ? "Invoke" : "Revoke"} Status
                  </th>

                  <th className="text-left w-[18%]">
                    {loanAction === "invoke" ? "Invoke" : "Revoke"} / Cancel
                    Criteria
                  </th>
                  <th className={`text-left w-[14%] ml-[5%]`}>Date </th>
                  <th className={`text-right w-[10%]`}>Timeline</th>
                </tr>
              </thead>

              <tbody
                className={` overflow-y-scroll max-h-[calc(100vh-375px)]  `}
              >
                {data?.map((data, index) => (
                  <tr
                    key={index}
                    className={` ${
                      index % 2 === 0 ? "bg-[#f8f8f8]" : ""
                    } text-xs font-medium w-full flex items-center hover:bg-[#e6ebed] `}
                  >
                    <td className="text-left pl-6 pr-4  w-[17%]">
                      {truncateText(data?.name) || "--"}
                    </td>
                    <td
                      className={`text-left w-[16%] pt-3 pb-2 text-[#004682]`}
                    >
                      <button>
                        {" "}
                        <Link
                          to={`../individuals/${data.user_uuid}?name=${data.name}`}
                        >
                          {data?.reference_no || "--"}
                        </Link>
                      </button>
                    </td>
                    <td className={`text-left w-[18%]  flex items-center`}>
                      <span
                        className={`py-[2px] px-2 ${
                          getStatusColor(data?.order_status).bg
                        } ${
                          getStatusColor(data?.order_status).text
                        } rounded-xl `}
                      >
                        {data?.order_status || "--"}
                      </span>
                    </td>
                    <td className="text-Lleft  w-[18%]">
                      {" "}
                      {data.cancel_criteria || "--"}
                    </td>
                    <td className={`text-left w-[14%] ml-[5%]`}>
                      {data.date || "--"}
                    </td>
                    <td className={`text-right w-[10%] `}>
                      {" "}
                      <button
                        onClick={(e) => {
                          handlePosition(e, data);
                          setUnderline(index);
                        }}
                        className={`text-[#0070d2] hover:underline ${
                          underline === index ? " underline" : ""
                        }`}
                      >
                        See timeline
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div className=" bg-white rounded-b-lg">
          <TableFooter
            totalPages={noOfPages}
            totalRows={noOfRows}
            rowsPerPage={rowsPerPage}
            startIndex={startIndex}
            setStartIndex={setStartIndex}
            setEndIndex={setEndIndex}
            endIndex={endIndex}
            setPageNo={setPageNo}
            pageNo={pageNo}
            setRowsPerPage={setRowsPerPage}
          />
        </div>
        {showTimeLine && (
          <div className=" overlayModal2" onClick={handleOverlay}>
            <div
              style={{
                top: `${divPosition.top}px`,
                left: `${divPosition.left}px`,
              }}
              className={` w-[327px]  ${
                arrowPosition === "bottom" ? " min-h-[240px] " : ""
              } pb-3 bg-white rounded-lg   absolute z-[1000]  px-4 drop-shadow-2xl`}
            >
              <div className=" mt-[24px] flex justify-between items-center">
                <p className=" text-base font-bold">Timeline</p>
                <button
                  onClick={() => {
                    setShowTimeLine(false);
                    setUnderline(false);
                  }}
                >
                  <IoCloseSharp
                    style={{
                      width: "23px",
                      height: "23px",
                    }}
                  />
                </button>
              </div>
              <div className=" mt-4 font-medium ">
                <p className="text-xs">{timelineUser.name || "--"}</p>
                <p className="text-xs mt-1 text-[#004682]">
                  {timelineUser.reference_no || "--"}
                </p>
              </div>
              <div className="  max-h-[190px] overflow-auto mt-[2px]">
                <Stepper timeline={timelineData} />
              </div>
              <div
                className={`absolute  ${
                  arrowPosition === "bottom"
                    ? " top-[171px] left-[320px]"
                    : " left-[320px] top-14"
                }`}
                onClick={() => {
                  setShowTimeLine(false);
                }}
              >
                <RightArrow />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LogModal;
